import handlerCreator from 'utils/handlerUtils'

export const handleContactFinancialAccountRoles = handlerCreator('contactFinancialAccountRoles')
export const handleReciprocalRoles = handlerCreator('reciprocalRoles')
export const handleContactRelationships = handlerCreator('contactRelationships')
export const handleContactTypes = handlerCreator('contactTypes')
export const handleContacts = handlerCreator('contacts')

export const handleContactsPageRequests = async (dispatch, getState) => {
  await Promise.all([
    handleContacts(dispatch, getState),
    handleContactFinancialAccountRoles(dispatch, getState),
    handleReciprocalRoles(dispatch, getState),
    handleContactRelationships(dispatch, getState)
  ])
}

export const handleEditContactPageRequests = async (dispatch, getState) => {
  await Promise.all([
    handleContacts(dispatch, getState),
    handleContactFinancialAccountRoles(dispatch, getState),
    handleReciprocalRoles(dispatch, getState),
    handleContactRelationships(dispatch, getState),
    handleContactTypes(dispatch, getState)
  ])
}

export const handleAddContactPageRequests = async (dispatch, getState) => {
  await Promise.all([
    handleContacts(dispatch, getState),
    handleContactFinancialAccountRoles(dispatch, getState),
    handleReciprocalRoles(dispatch, getState),
    handleContactRelationships(dispatch, getState),
    handleContactTypes(dispatch, getState)
  ])
}



// WEBPACK FOOTER //
// ./src/routing/thunks/handlers/onboarding.js